/**
 * Unified Authentication Configuration
 * 
 * Switch between authentication providers by changing AUTH_PROVIDER
 * Supported: 'OKTA' | 'MSAL'
 */

// Change this value to switch authentication provider
export const AUTH_PROVIDER = window.REACT_APP_AUTH_PROVIDER ; // 'OKTA' or 'MSAL'

// Provider-specific configurations
export const AUTH_CONFIG = {
  OKTA: {
    issuer: window.OKTA_ISSUER,
    clientId: window.OKTA_CLIENT_ID,
    redirectUri: window.OKTA_REDIRECT_URI,
    postLogoutRedirectUri: window.OKTA_POST_LOGOUT_URI,
    scopes: ['openid', 'profile', 'email', 'pepappbuyconroles', 'offline_access'],
    pkce: true,
    tokenManager: {
      autoRenew: true,
      secure: true,
      expireEarlySeconds: 600,
    },
  },
  MSAL: {
    clientId: window.MSAL_CLIENT_ID,
    authority: window.MSAL_AUTHORITY,
  //  redirectUri: `${window.location.origin}/login`,
    //postLogoutRedirectUri: window.location.origin,
    redirectUri: window.MSAL_REDIRECT_URI,
    postLogoutRedirectUri: window.MSAL_POST_LOGOUT_URI,
    scopes: window.MSAL_SCOPES,
  }
};

export const isOkta = () => window.REACT_APP_AUTH_PROVIDER === 'OKTA';
export const isMsal = () => window.REACT_APP_AUTH_PROVIDER === 'MSAL';
